<template>
  <main class="md:px-44 px-7">
    <section class="grid pt-9 pb-4 gap-16 content-start items-start w-full">
      <article class="grid gap-4 md:w-80 md:mx-auto justify-center">
        <div class="h-64 w-44 justify-self-center">
          <Vue3Lottie ref="lottie" :animationData="AutoCrossAnimation" :speed="1" :loop="true" />
        </div>
        <div class="grid gap-5 text-center">
          <p class="text-3xl font-blogger font-bold text-headingColor">Payment Failed</p>
          <p class="text-center text-headingColor font-myriad text-base width17rem">If money has been deducted from your bank account, then the same will be credited back in the form of loyalty points within 24 hours</p>
        </div>
      </article>
    </section>
    <span class="grid pb-24"></span>
    <!-- overLayGoBack -->
    <over-lay-go-back :starterOverLay="isOverLay" @on-click-back-prev="handleBackToPrev"/>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import overLayGoBack from '../components/overLayGoBack.vue';
import AutoCrossAnimation from '../assets/animation/Auto-Cross-Animation.json';

export default {
  name: 'PaymentFailure',
  components: {
    overLayGoBack,
  },
  computed: {
    ...mapGetters(['transactionId'])
  },
  mounted() {
    setTimeout(() => {
      this.isOverLay = true;
    }, 4000);
  },
  data() {
    return {
      isOverLay: undefined,
      queryData: this.$route.query,
      AutoCrossAnimation
    };
  },
  methods: {
    handleBackToPrev() {
      this.isOverLay = false;
      setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
    }
  }
};
</script>
<style lang="scss" scoped>
.width17rem{
  width: 17rem;
}
</style>
